module.exports = __webpack_public_path__ + "img/lender_benefit_hero_mobile.c3985ee1.jpg";